/*
 * @Author: yuchen
 * @Date: 2021-04-09 14:38:52
 * @LastEditTime: 2021-04-09 14:41:24
 * @LastEditors: yuchen
 * @Description: 触发模拟a标签的点击
 */
const triggerLinkClick = (url) => {
    const aLink = document.createElement('a');
    aLink.href = encodeURI(url);
    aLink.click();
};

export { triggerLinkClick };
